import { render, staticRenderFns } from "./BoxHelpTypology.vue?vue&type=template&id=2bf56405"
import script from "./BoxHelpTypology.vue?vue&type=script&lang=js"
export * from "./BoxHelpTypology.vue?vue&type=script&lang=js"
import style0 from "./BoxHelpTypology.vue?vue&type=style&index=0&id=2bf56405&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports